<template>
  <div
    class="textarea-wrap"
    :style="{ height: height }"
  >
    <div
      v-show="showPlaceholder"
      class="placeholder"
      @click="handleFocus"
    >
      {{ placeholder || $t('message["751"]') }}
    </div>
    <div
      ref="textarea"
      class="textarea"
      :placeholder="placeholder"
      contenteditable="true"
      @click="handleFocus"
      @blur="handleBLur"
      @input="handleChange"
      v-html="value"
    />
    <cube-validator
      ref="formItem"
      v-model="data.valid"
      :model="data.fieldvalue"
      :data="data"
      :rules="data.rules"
      :messages="data.messages"
      :immediate="false"
    />
  </div>
</template>
<script>
export default {
  inject: {
    myForm: {
      type: Object,
      default: null
    }
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    placeholder: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: '200px'
    }
  },
  data () {
    return {
      value: this.data.fieldvalue,
      showPlaceholder: this.data.fieldvalue === '' || this.data.fieldvalue === undefined,
      isLocked: false,
      isFistTime: true
    }
  },

  watch: {
    data (newValue, oldValue) {
      if (!this.isLocked || !this.value) {
        if (!this.value) {
          this.$nextTick(() => {
            this.keepLastIndex(this.$refs.textarea)
          })
        }
        this.value = this.data.fieldvalue
      }
      this.isFistTime = false
    },
    isLocked () {
      this.value = this.data.fieldvalue
    }
  },

  methods: {
    validate (cb) {
      this.$refs.formItem.validate(cb)
    },
    handleChange () {
      let val = this.$refs.textarea && this.$refs.textarea.innerText
      this.data.fieldvalue = val
      // let reg = /<[^<>]+>/g
      // this.data.fieldvalue = val.replace(reg, '')
      this.$emit('change', this.data.fieldvalue)
    },
    keepLastIndex (obj) {
      console.log(obj)
      console.log(window.getSelection)
      console.log(document.selection)
      if (window.getSelection) { // ie11 10 9 ff safari
        obj.focus() // 解决ff不获取焦点无法定位问题
        let range = window.getSelection() // 创建range
        range.selectAllChildren(obj) // range 选择obj下所有子内容
        range.collapseToEnd() // 光标移至最后
      } else if (document.selection) { // ie10 9 8 7 6 5
        let range = document.selection.createRange() // 创建选择对象
        // var range = document.body.createTextRange();
        range.moveToElementText(obj) // range定位到obj
        range.collapse(false) // 光标移至最后
        range.select()
      }
    },
    handleFocus () {
      this.isLocked = true
      this.showPlaceholder = false
      this.$refs.textarea && this.$refs.textarea.focus()
    },
    handleBLur () {
      this.isLocked = false
      if (this.data.fieldvalue === '' || this.data.fieldvalue === undefined) {
        this.showPlaceholder = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.textarea-wrap ::v-deep {
  position: relative;
  width: 100%;
  margin: 10px 0;
  padding: 10px;
  overflow: auto;
  background-color: #fff;
  border: solid 1px #ebebeb;
  border-radius: 4px;
  .textarea {
    min-height: 100%;
    outline: none;
    z-index: 2;
  }
  img {
    max-width: 100%;
  }
  .placeholder {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding: 10px;
    line-height: 1;
    color: #999;
    font-size: 14px;
  }
}
.cube-validator {
  position: absolute;
  bottom: 4px;
  z-index: 1;
}
</style>
